import React from 'react';
import styled from 'styled-components';

export type Props = React.HTMLAttributes<HTMLDivElement> & {
  className?: string;
  imageUrl: string;
};

const Root = styled.div`
  overflow: hidden;
  position: relative;
  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 90px;
  }
`;

const Image = styled.img`
  height: 90px;
  left: 0;
  object-fit: cover;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;
`;

const ImagePreview = ({ className, imageUrl, ...rest }: Props) => {
  return (
    <Root {...rest} className={className}>
      <Image src={imageUrl} />
    </Root>
  );
};

export default ImagePreview;
